export default "__VITE_ASSET__sX_BlhDO__"